import ComplianceMessagingProvider from './ComplianceMessagingProvider';

export default ComplianceMessagingProvider;
